
import { React, ui } from "aaa";
import { ConfirmationDialog } from "../common/ConfirmationDialog";

export const GIGActivationDialog = (props: {
    show: boolean,
    onClose: (activateDesktop?: boolean) => void,
}): any => {
    return (
        <ConfirmationDialog
            show={props.show}
            onClose={props.onClose}
            title={ui.__("gig.activation.dialog.title")}
            message={ui.__("gig.activation.dialog.text")}
            labelCancel={ui.__("common.ok")}
        />
    );
};


// WEBPACK FOOTER //
// ./src/components/gig/GIGActivationDialog.tsx